module.exports = __webpack_public_path__ + "media/images/covid/banner/vi-4077a3c1464dd872164b4bf752428cbb.jpg";